


































































































import { Component, Vue } from "vue-property-decorator";
import AddAirport from "./modals/addAirport.vue";
import Country from "@/store/entities/country";

@Component({
  components: { AddAirport },
})
export default class Airports extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  airports: Airports[] = [];

  created() {
    this.getAirports();

    (this.headers = [
      { text: "ID", value: "id" },
      { text: "İsim", value: "name" },
      { text: "Rusça", value: "russian" },
      { text: "Ülke", value: "country" },
      { text: "Şehir", value: "city" },
      { text: "Aktif mi?", value: "airportIsActive" },
      { text: "Şehir mi?", value: "isCity" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          id: "AYT",
          name: "Antalya, Turkey (AYT-Antalya Intl.)	",
          country: "Turkey",
          city: "Antalya",
          latitude: "50.026049",
          longitude: "50.026049",
          expediald: "1111111",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Havaalanları", disabled: true },
    ];
  }

  async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
    });

    this.airports = this.$store.state.airport.list;
  }

  editAirport(item) {
    this.$store.state.airport.editAirport = item;
    this.isOpenModal = true;
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getAirports();
  }
  cancelModal() {
    this.isOpenModal = false;
  }
}
